import React from "react";
import styles from "./styles/AuthorisedServiceCentre.module.css";
import Header from "../../shared/Header/Header";
import Footer from "../../shared/Footer/Footer";
import ServiceCentreHero from "./ServiceCentreHero";
import ServiceCentreProducts from "./ServiceCentreProducts";
import ServiceCentreCTA from "./ServiceCentreCTA";

export default function AuthorisedServiceCentre() {
  return (
    <div className={styles.page}>
      <Header />
      <main>
        <ServiceCentreHero />
        <ServiceCentreProducts />
        <ServiceCentreCTA />
      </main>
      <Footer />
    </div>
  );
}
